<template>
  <div id="q-app">
    <router-view />
  </div>
</template>

<script>
import { colors } from 'quasar';
import { styles } from '@client/utils/app-config';

export default {
  name: 'App',
  mounted() {
    Object.keys(styles.colors).forEach((type) => {
      const userColor = localStorage.getItem(`${type}-color`);
      if (userColor) {
        colors.setBrand(type, userColor);
      } else {
        colors.setBrand(type, styles.colors[type]);
      }
    });

    const darkMode = localStorage.getItem('dark-mode');
    if (darkMode === 'true') {
      this.$q.dark.set(true);
    } else {
      this.$q.dark.set(styles.darkMode);
    }
  }
};
</script>
